import { usePageExperienceContext } from './usePageExperienceContext';

/**
 * Whether the rendered header shows its title at all, from the author's Title
 * switch in the Views panel.
 *
 * Read off the experience in context, which for a planner is the view being
 * rendered — the switch is per-view, like the title itself (see
 * {@link useHeaderTitle}) rather than per-planner. Distinct from a title that
 * resolves empty: an unset title falls back to the planner's, where this hides
 * the block outright.
 */
export const useHeaderTitleEnabled = (): boolean => {
  const { experience } = usePageExperienceContext();

  // Only an explicit false hides it. The column is non-null and defaults true,
  // so the one way to read undefined here is an experience that predates the
  // field — a cached query result, or a partial fixture — and defaulting those
  // to hidden would blank a header the author never touched.
  return experience.headerTitleEnabled !== false;
};
